import { printWithTheme } from "../utils/typography";
﻿// src/components/DebtsTable.jsx

import React, { useEffect, useMemo, useState, useRef } from "react";

import { supabase } from "../supabaseClient";

import logo from "../assets/PdfImagetrs.png";

function DebtsTable({ user }) {

  const [debts, setDebts] = useState([]);

  const [loading, setLoading] = useState(true);

  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [sales, setSales] = useState([]);

  const [saleDetails, setSaleDetails] = useState([]);

  const [payments, setPayments] = useState([]);

  const [returns, setReturns] = useState([]);

  const [returnDetails, setReturnDetails] = useState([]);

  const [showDetails, setShowDetails] = useState(false);

  const printRef = useRef();
  const statementPrintRef = useRef();

  useEffect(() => {

    fetchDebts();

  }, []);

  const returnRefundMap = useMemo(() => {

    const map = {};

    returnDetails.forEach((d) => {

      map[d.return_id] =

        (map[d.return_id] || 0) + Number(d.line_refund_amount || 0);

    });

    returns.forEach((r) => {

      if (map[r.id] == null) {

        map[r.id] = Number(r.total_refund || 0) || 0;

      }

    });

    return map;

  }, [returnDetails, returns]);

  function getReturnAmount(returnId) {

    return Number(returnRefundMap[returnId] || 0);

  }

  // Ø§Ø­Ø³Ø¨ ØµØ§ÙÙŠ ÙƒÙ„ ÙØ§ØªÙˆØ±Ø© = Ù…Ø¬Ù…ÙˆØ¹ Ø¨Ù†ÙˆØ¯Ù‡Ø§ - discount_value

  function computeSaleNet(subtotal, sale) {

    const sub = Number(subtotal || 0);

    if (sale && sale.net_total != null && sale.net_total !== "") {

      return Number(sale.net_total) || 0;

    }

    if (sale && sale.discount_amount != null && sale.discount_amount !== "") {

      const discountAmount = Number(sale.discount_amount) || 0;

      return Math.max(0, sub - discountAmount);

    }

    let discount = 0;

    if (sale?.discount_type === "percent") {

      const pct = Number(sale.discount_value) || 0;

      discount = sub * (pct / 100);

    } else {

      discount = Number(sale?.discount_value || 0);

    }

    return Math.max(0, sub - discount);

  }

  async function fetchDebts() {

    setLoading(true);

    const { data: customers } = await supabase

      .from("customer")

      .select("id, name");

    // Ù‡Ù†Ø­ØªØ§Ø¬ Ø§Ù„Ø®ØµÙ… Ø¹Ù„Ù‰ Ù…Ø³ØªÙˆÙ‰ Ø§Ù„ÙØ§ØªÙˆØ±Ø©

    const { data: salesData } = await supabase

      .from("sale")

      .select(

        "id, customer_id, date, discount_value, discount_type, discount_amount, net_total, showroom_id"

      );

    const { data: saleDetailsData } = await supabase

      .from("sale_details")

      .select("sale_id, total_price");

    const { data: paymentsData } = await supabase

      .from("payment")

      .select("customer_id, amount, payment_date, notes");

    const { data: returnNotesData } = await supabase

      .from("return_note")

      .select("id, customer_id, total_refund");

    let returnDetailsData = [];

    if ((returnNotesData || []).length) {

      const returnIds = returnNotesData.map((r) => r.id);

      const { data: rdData } = await supabase

        .from("return_note_details")

        .select("return_id, line_refund_amount")

        .in("return_id", returnIds);

      returnDetailsData = rdData || [];

    }

    // Ø§Ø¬Ù…Ø¹ subtotal Ù„ÙƒÙ„ ÙØ§ØªÙˆØ±Ø© Ù…Ù† sale_details

    const saleSubtotals = {};

    (saleDetailsData || []).forEach((sd) => {

      saleSubtotals[sd.sale_id] =

        (saleSubtotals[sd.sale_id] || 0) + Number(sd.total_price || 0);

    });

    // Ø§Ø¬Ù…Ø¹ ØµØ§ÙÙŠ Ù…Ø¨ÙŠØ¹Ø§Øª ÙƒÙ„ Ø¹Ù…ÙŠÙ„ Ø¨Ø¹Ø¯ Ø§Ù„Ø®ØµÙ…

    const customerSalesNet = {};

    (salesData || []).forEach((s) => {

      const sub = saleSubtotals[s.id] || 0;

      const net = computeSaleNet(sub, s);

      customerSalesNet[s.customer_id] =

        (customerSalesNet[s.customer_id] || 0) + net;

    });

    // Ø§Ø¬Ù…Ø¹ Ø§Ù„Ù…Ø¯ÙÙˆØ¹Ø§Øª Ù„ÙƒÙ„ Ø¹Ù…ÙŠÙ„

    const customerPayments = {};

    (paymentsData || []).forEach((p) => {

      customerPayments[p.customer_id] =

        (customerPayments[p.customer_id] || 0) + Number(p.amount || 0);

    });

    const refundByReturnId = {};

    (returnDetailsData || []).forEach((rd) => {

      refundByReturnId[rd.return_id] =

        (refundByReturnId[rd.return_id] || 0) +

        Number(rd.line_refund_amount || 0);

    });

    const customerReturns = {};

    (returnNotesData || []).forEach((r) => {

      const refund =

        refundByReturnId[r.id] != null

          ? refundByReturnId[r.id]

          : Number(r.total_refund || 0);

      customerReturns[r.customer_id] =

        (customerReturns[r.customer_id] || 0) + Number(refund || 0);

    });

    // Ø­Ø¶Ù‘Ø± ØµÙÙˆÙ Ø§Ù„Ù…Ø¯ÙŠÙˆÙ†ÙŠØ© (Ø§Ù„Ù…ØªØ¨Ù‚ÙŠ = ØµØ§ÙÙŠ Ø§Ù„Ù…Ø¨ÙŠØ¹Ø§Øª - Ø§Ù„Ù…Ø¯ÙÙˆØ¹Ø§Øª)

    const debtsArr = (customers || []).map((c) => {

      const totalSalesNet = customerSalesNet[c.id] || 0;

      const totalPayments = customerPayments[c.id] || 0;

      const totalReturns = customerReturns[c.id] || 0;

      const balance = totalSalesNet - totalPayments - totalReturns;

      return {

        id: c.id,

        name: c.name,

        totalSalesNet,

        totalPayments,

        totalReturns,

        balance,

      };

    });

    // Ù†Ø®ÙÙŠ Ø§Ù„Ø­Ø³Ø§Ø¨Ø§Øª Ø§Ù„ØµÙØ±ÙŠØ©ØŒ ÙˆÙ†ÙØ¨Ù‚ÙŠ Ø§Ù„Ù…ÙˆØ¬Ø¨ (Ù…Ø·Ù„ÙˆØ¨ Ù…Ù† Ø§Ù„Ø¹Ù…ÙŠÙ„) ÙˆØ§Ù„Ø³Ø§Ù„Ø¨ (Ù„ØµØ§Ù„Ø­ Ø§Ù„Ø¹Ù…ÙŠÙ„)

    setDebts(debtsArr.filter((d) => Number(d.balance || 0) !== 0));

    setLoading(false);

  }

  async function openCustomerDetails(customer) {
    setShowDetails(false);
        // Ù‡Ù†Ø³Ø­Ø¨ Ø§Ù„Ø®ØµÙ… Ù…Ø¹ Ø§Ù„ÙØ§ØªÙˆØ±Ø©

    const { data: customerSalesData } = await supabase

      .from("sale")

      .select("*")

      .eq("customer_id", customer.id)

      .order("date", { ascending: false });

    const saleIds = (customerSalesData || []).map((s) => s.id);

    let customerSaleDetailsData = [];

    if (saleIds.length > 0) {

      const { data: sdData } = await supabase

        .from("sale_details")

        .select("*")

        .in("sale_id", saleIds);

      customerSaleDetailsData = sdData || [];

    }

    const { data: customerPaymentsData } = await supabase

      .from("payment")

      .select("*")

      .eq("customer_id", customer.id)

      .order("payment_date", { ascending: false });

    const { data: customerReturnsData } = await supabase

      .from("return_note")

      .select("id, date, customer_id, original_sale_id, total_refund, notes")

      .eq("customer_id", customer.id)

      .order("date", { ascending: false });

    let customerReturnDetails = [];

    if ((customerReturnsData || []).length) {

      const returnIds = customerReturnsData.map((r) => r.id);

      const { data: rdData } = await supabase

        .from("return_note_details")

        .select("return_id, line_refund_amount")

        .in("return_id", returnIds);

      customerReturnDetails = rdData || [];

    }

    setSelectedCustomer(customer);

    setSales(customerSalesData || []);

    setSaleDetails(customerSaleDetailsData);

    setPayments(customerPaymentsData || []);

    setReturns(customerReturnsData || []);

    setReturnDetails(customerReturnDetails);

    setShowDetails(true);

  }

  // Ø§Ù„Ø±ØµÙŠØ¯ Ø§Ù„Ø­Ø§Ù„ÙŠ = (ØµØ§ÙÙŠ Ø¬Ù…ÙŠØ¹ Ø§Ù„ÙÙˆØ§ØªÙŠØ±) - (Ø¥Ø¬Ù…Ø§Ù„ÙŠ Ø§Ù„Ù…Ø¯ÙÙˆØ¹Ø§Øª)

  function calcCustomerBalance() {

    // subtotal Ù„ÙƒÙ„ ÙØ§ØªÙˆØ±Ø©

    const subtotalsBySale = {};

    saleDetails.forEach((d) => {

      subtotalsBySale[d.sale_id] =

        (subtotalsBySale[d.sale_id] || 0) + Number(d.total_price || 0);

    });

    // ØµØ§ÙÙŠ Ù„ÙƒÙ„ ÙØ§ØªÙˆØ±Ø© Ø¨Ø¹Ø¯ Ø§Ù„Ø®ØµÙ…

    const totalSalesNet = sales.reduce((sum, s) => {

      const sub = subtotalsBySale[s.id] || 0;

      const net = computeSaleNet(sub, s);

      return sum + net;

    }, 0);

    const totalPayments = payments.reduce(

      (sum, p) => sum + Number(p.amount || 0),

      0

    );

    const totalReturns = returns.reduce(

      (sum, r) => sum + getReturnAmount(r.id),

      0

    );

    return totalSalesNet - totalPayments - totalReturns;

  }

  const statementRows = useMemo(() => {

    const rows = [];

    const subtotals = {};

    saleDetails.forEach((d) => {

      subtotals[d.sale_id] =

        (subtotals[d.sale_id] || 0) + Number(d.total_price || 0);

    });

    sales.forEach((sale) => {

      const subtotal = subtotals[sale.id] || 0;

      const net = computeSaleNet(subtotal, sale);

      rows.push({

        key: "sale-" + sale.id,

        date: sale.date,

        label: "Sales",

        details: sale.invoice_no

          ? "Invoice " + sale.invoice_no

          : "Invoice " + sale.id,

        debit: net,

        credit: 0,

        order: 1,

      });

    });

    payments.forEach((p) => {

      rows.push({

        key: "pay-" + p.id,

        date: p.payment_date,

        label: "Payment",

        details: p.notes ? "Payment (" + p.notes + ")" : "Payment",

        debit: 0,

        credit: Number(p.amount || 0),

        order: 2,

      });

    });

    returns.forEach((r) => {
      const amount = getReturnAmount(r.id);
      if (!amount) return;
      rows.push({
        key: "return-" + r.id,
        date: r.date,
        label: "Sales returns",
        details: r.original_sale_id

          ? "Invoice returns #" + r.original_sale_id

          : r.notes || "Returns",

        debit: 0,

        credit: amount,

        order: 3,

      });

    });

    const parseDate = (value) => {

      const ts = Date.parse(value);

      return Number.isNaN(ts) ? 0 : ts;

    };

    rows.sort((a, b) => parseDate(a.date) - parseDate(b.date) || a.order - b.order);

    let balance = 0;

    const withBalance = rows.map((row) => {

      balance += Number(row.debit || 0) - Number(row.credit || 0);

      return { ...row, balance };

    });

    return [

      {

        key: "opening",

        date: "",

        label: "Opening balance",

        details: "",

        debit: 0,

        credit: 0,

        balance: 0,

      },

      ...withBalance,

    ];

  }, [payments, returns, saleDetails, sales, returnRefundMap]);

  const totalPositiveDebts = debts.reduce((sum, d) => sum + (d.balance > 0 ? d.balance : 0), 0);

  // Ø·Ø¨Ø§Ø¹Ø© Ø¬Ø¯ÙˆÙ„ Ø§Ù„Ù…Ø¯ÙŠÙˆÙ†ÙŠØ§Øª

  function handlePrint() {

    if (!printRef.current) return;

    const printContent = printRef.current.innerHTML;

    const printWindow = window.open("", "", "width=800,height=600");

    printWindow.document.write(`

      <html dir="ltr" lang="ar">

        <head>

          <title>Print statement</title>

          <style>

            body { font-family: Jost, 'Trebuchet MS', Arial, sans-serif; padding: 40px 30px; direction: ltr; background-color: #f2ede4; color: var(--accent, #514536); }

            img.logo { display: block; margin: 0 auto 25px auto; max-width: 110px; height: auto; filter: drop-shadow(0 2px 3px rgba(81,69,54,0.15)); }

            table { border-collapse: collapse; width: 100%; box-shadow: 0 4px 12px rgb(81 69 54 / 0.1); border-radius: 12px; overflow: hidden; }

            th, td { border: 1px solid #d2cbc1; padding: 12px 15px; text-align:left; font-size: 15px; }

            th { background-color: #f2ede4; font-weight: bold; }

            tbody tr:nth-child(even) { background-color: #faf8f4; }

            tbody tr:hover { background-color: #d2cbc1; }

            h3, h4 { color: var(--accent, #514536); margin-bottom: 12px; }

            ul { padding-inline-start: 20px; }

          </style>

        </head>

        <body>

          <img src="${logo}" alt="Logo" class="logo" />

          ${printContent}

        </body>

      </html>

    `);

    printWindow.document.close();

    printWindow.focus();

    printWithTheme(printWindow);

    printWindow.close();

  }

  function handlePrintStatement() {
    if (!statementPrintRef.current) return;
    const content = statementPrintRef.current.innerHTML;
    const name = selectedCustomer?.name || "";
    const printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write(`
      <html dir="ltr" lang="ar">
        <head>
          <title>Print customer statement</title>
          <style>
            body { font-family: Jost, 'Trebuchet MS', Arial, sans-serif; padding: 30px; direction: ltr; color: var(--accent, #514536); }
            h3 { text-align: center; margin-bottom: 16px; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #d2cbc1; padding: 10px; text-align:left; font-size: 14px; }
            th { background: #f2ede4; }
            tbody tr:nth-child(even) { background: #faf8f4; }
          </style>
        </head>
        <body>
          <h3>Statement: ${name}</h3>
          ${content}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWithTheme(printWindow);
    printWindow.close();
  }

  return (

    <div className="ui-legacy-page" dir="ltr" style={{ maxWidth: 900, margin: "auto", fontFamily: "Jost, 'Trebuchet MS', Arial, sans-serif" }}>

      <div className="ui-page-header"><h2 style={{ color: "var(--accent, #514536)", marginBottom: 20 }}>Outstanding balances</h2>

      <button className="ui-primary"

        onClick={handlePrint}

        style={{

          background: "var(--accent, #514536)",

          color: "#f2ede4",

          padding: "10px 22px",

          borderRadius: 7,

          border: "none",

          cursor: "pointer",

          marginBottom: 20,

        }}

      >

        Print outstanding balances

      </button></div>

      {loading ? (

        <div>Loading records...</div>

      ) : (

        <>

          {/* الجدول اللي هنطبعه */}

          <div ref={printRef}>

            <div className="ui-table-scroll"><table

              style={{

                width: "100%",

                borderCollapse: "collapse",

                background: "#faf8f4",

                direction: "ltr",

                textAlign: "left",

                fontSize: 15,

              }}

            >

                            <thead>
                <tr style={{ background: "#d2cbc1" }}>
                  <th style={{ padding: 10 }}>#</th>
                  <th style={{ padding: 10 }}>{"Customer name"}</th>
                  <th style={{ padding: 10 }}>{"Total sales (after discount)"}</th>
                  <th style={{ padding: 10 }}>{"Total payments"}</th>
                  <th style={{ padding: 10 }}>{"Balance"}</th>
                  <th style={{ padding: 10 }}>{"Statement"}</th>
                </tr>
              </thead>

              <tbody>

                {debts.length === 0 && (

                  <tr>

                    <td colSpan={6} style={{ textAlign: "center", color: "#716759", padding: 20 }}>
                      {"No outstanding balances"}
                    </td>

                  </tr>

                )}

                {debts.map((d, i) => {

                  const isPositive = Number(d.balance) > 0; // Ø¹Ù„ÙŠÙ‡ ÙÙ„ÙˆØ³

                  const isNegative = Number(d.balance) < 0; // Ù„Ù‡ ÙÙ„ÙˆØ³ Ø¹Ù†Ø¯Ù†Ø§

                  const color = isPositive ? "#514536" : isNegative ? "#514536" : "var(--accent, #514536)";

                  return (

                    <tr

                      key={d.id}

                      style={{

                        color,

                        fontWeight: "bold",

                        cursor: "pointer",

                      }}

                      onClick={() => openCustomerDetails(d)}

                    >

                      <td style={{ padding: 10 }}>{i + 1}</td>

                      <td style={{ padding: 10, textDecoration: "underline" }}>{d.name}</td>

                      <td style={{ padding: 10 }}>{d.totalSalesNet.toLocaleString()}</td>

                      <td style={{ padding: 10 }}>{d.totalPayments.toLocaleString()}</td>

                      <td style={{ padding: 10 }}>

                        {isPositive ? "+" : ""}

                        {d.balance.toLocaleString()}

                      </td>
                      <td style={{ padding: 10 }}><div className="ui-actions">
                        <button className="ui-primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            openCustomerDetails(d);
                          }}
                          style={{
                            background: "var(--accent, #514536)",
                            color: "#faf8f4",
                            border: "none",
                            padding: "6px 12px",
                            borderRadius: 6,
                            cursor: "pointer",
                            fontSize: 13,
                          }}
                        >
                          {"Statement"}
                        </button>
                      </div></td>

                    </tr>

                  );

                })}

              </tbody>

              {debts.length > 0 && (

                <tfoot>

                  <tr style={{ background: "#f2ede4", fontWeight: "bold" }}>

                    <td colSpan={5} style={{ padding: 12, textAlign: "center" }}>
                      {"Total customer balances"}
                    </td>

                    <td

                      style={{

                        padding: 12,

                        color: totalPositiveDebts > 0 ? "#514536" : "var(--accent, #514536)",

                        fontWeight: "bold",

                      }}

                    >

                      {totalPositiveDebts.toLocaleString()}

                    </td>

                  </tr>

                </tfoot>

              )}

            </table></div>

          </div>

          {/* Ù†Ø§ÙØ°Ø© ØªÙØ§ØµÙŠÙ„ Ø§Ù„Ø¹Ù…ÙŠÙ„ */}

                    {showDetails && (
            <div className="ui-backdrop"
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(81,69,54,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 3000,
                padding: 20,
              }}
              onClick={() => {
                setShowDetails(false);
                
              }}
            >
              <div className="ui-modal"
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: "#f2ede4",
                  borderRadius: 8,
                  padding: 20,
                  width: "90%",
                  maxWidth: 700,
                  maxHeight: "80vh",
                  overflowY: "auto",
                  direction: "ltr",
                  color: "var(--accent, #514536)",
                }}
              >
                <h3 style={{ marginTop: 0, marginBottom: 10 }}>
                  {"Statement: "} {selectedCustomer?.name}
                </h3>
                <div ref={statementPrintRef} style={{ overflowX: "auto", marginBottom: 12 }}>
                  <div className="ui-table-scroll"><table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      background: "#faf8f4",
                      fontSize: 14,
                      minWidth: 640,
                    }}
                  >
                    <thead>
                      <tr style={{ background: "#f2ede4" }}>
                        <th style={{ padding: 8, border: "1px solid #d2cbc1", textAlign: "left" }}>
                          {"Date"}
                        </th>
                        <th style={{ padding: 8, border: "1px solid #d2cbc1", textAlign: "left" }}>
                          {"Transaction"}
                        </th>
                        <th style={{ padding: 8, border: "1px solid #d2cbc1", textAlign: "left" }}>
                          {"Details"}
                        </th>
                        <th style={{ padding: 8, border: "1px solid #d2cbc1", textAlign: "left" }}>
                          {"Debit"}
                        </th>
                        <th style={{ padding: 8, border: "1px solid #d2cbc1", textAlign: "left" }}>
                          {"Credit"}
                        </th>
                        <th style={{ padding: 8, border: "1px solid #d2cbc1", textAlign: "left" }}>
                          {"Balance"}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {statementRows.length === 0 ? (
                        <tr>
                          <td colSpan={6} style={{ padding: 10, textAlign: "center", color: "#716759" }}>
                            {"No transactions"}
                          </td>
                        </tr>
                      ) : (
                        statementRows.map((row, idx) => {
                          const color =
                            row.balance > 0 ? "#514536" : row.balance < 0 ? "#514536" : "var(--accent, #514536)";
                          return (
                            <tr key={row.key || idx}>
                              <td style={{ padding: 8, border: "1px solid #d2cbc1" }}>
                                {row.date ? row.date.split("T")[0] : ""}
                              </td>
                              <td style={{ padding: 8, border: "1px solid #d2cbc1" }}>{row.label}</td>
                              <td style={{ padding: 8, border: "1px solid #d2cbc1" }}>
                                {row.details || "-"}
                              </td>
                              <td
                                style={{
                                  padding: 8,
                                  border: "1px solid #d2cbc1",
                                  color: row.debit ? "#514536" : "var(--accent, #514536)",
                                }}
                              >
                                {row.debit ? row.debit.toLocaleString() : ""}
                              </td>
                              <td
                                style={{
                                  padding: 8,
                                  border: "1px solid #d2cbc1",
                                  color: row.credit ? "#514536" : "var(--accent, #514536)",
                                }}
                              >
                                {row.credit ? row.credit.toLocaleString() : ""}
                              </td>
                              <td
                                style={{
                                  padding: 8,
                                  border: "1px solid #d2cbc1",
                                  fontWeight: "bold",
                                  color,
                                }}
                              >
                                {row.balance > 0 ? "+" : ""}
                                {row.balance.toLocaleString()}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table></div>
                </div>
                <div className="ui-actions" style={{ display: "flex", gap: 8, marginTop: 8 }}>
                  <button className="ui-primary"
                    onClick={handlePrintStatement}
                    style={{
                      background: "var(--accent, #514536)",
                      color: "#f2ede4",
                      padding: "8px 20px",
                      borderRadius: 7,
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {"Print statement"}
                  </button>
                  <button className="ui-secondary"
                    onClick={() => {
                      setShowDetails(false);
                      
                    }}
                    style={{
                      background: "#d2cbc1",
                      padding: "8px 20px",
                      borderRadius: 7,
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {"Close"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default DebtsTable;




